// extracted by mini-css-extract-plugin
module.exports =  {"scrollPropertiesList":"scrollPropertiesList___1TTP0","modalMessageWrapper":"modalMessageWrapper___dM9fA"};